import { IResumeExtractionResponse } from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { DataItemProps } from "../../../../../../shared/components/DataView";

export const mapResumeExtractedFieldsToDataView = (
  extractedFields: IResumeExtractionResponse
): DataItemProps[] => {
  const dataItems: DataItemProps[] = [];

  if (extractedFields.personalInfo?.fullName) {
    dataItems.push({
      label: "Full name",
      value: extractedFields.personalInfo.fullName
    });
  }

  if (extractedFields.personalInfo?.emailAddress) {
    dataItems.push({
      label: "Email address",
      value: extractedFields.personalInfo.emailAddress
    });
  }

  if (extractedFields.personalInfo?.phoneNumbers) {
    dataItems.push({
      label: "Phone numbers",
      value: extractedFields.personalInfo.phoneNumbers.join(", ")
    });
  }

  if (extractedFields.personalInfo?.location) {
    dataItems.push({
      label: "Location",
      value: `${extractedFields.personalInfo.location.city}, ${extractedFields.personalInfo.location.state}`
    });
  }

  if (extractedFields.personalInfo?.linkedinProfile) {
    dataItems.push({
      label: "LinkedIn profile",
      value: extractedFields.personalInfo.linkedinProfile
    });
  }

  if (extractedFields.personalInfo?.portfolioWebsite) {
    dataItems.push({
      label: "Portfolio website",
      value: extractedFields.personalInfo.portfolioWebsite
    });
  }

  if (extractedFields.professionalSummary?.summaryStatement) {
    dataItems.push({
      label: "Professional summary",
      value: extractedFields.professionalSummary.summaryStatement
    });
  }

  if (extractedFields.workExperience?.length > 0) {
    for (const [
      index,
      experience
    ] of extractedFields.workExperience.entries()) {
      dataItems.push({
        label: `Work experience ${index + 1}`,
        value: `${experience.companyName} - ${experience.jobTitle}`,
        fullWidth: true
      });
    }
  }

  if (extractedFields.education && extractedFields.education.length > 0) {
    for (const [index, education] of extractedFields.education.entries()) {
      dataItems.push({
        label: `Education ${index + 1}`,
        value: `${education.institutionName} - ${education.degreeType}`,
        fullWidth: true
      });
    }
  }

  if (
    extractedFields.skills?.technicalSkills &&
    extractedFields.skills.technicalSkills.length > 0
  ) {
    dataItems.push({
      label: "Technical skills",
      value: extractedFields.skills?.technicalSkills?.join(", ")
    });
  }

  if (
    extractedFields.skills?.softSkills &&
    extractedFields.skills.softSkills.length > 0
  ) {
    dataItems.push({
      label: "Soft skills",
      value: extractedFields.skills?.softSkills?.join(", ")
    });
  }

  if (
    extractedFields.skills?.languages &&
    extractedFields.skills.languages.length > 0
  ) {
    dataItems.push({
      label: "Languages",
      value: extractedFields.skills?.languages?.join(", ")
    });
  }

  if (extractedFields.skills?.skillCategories) {
    dataItems.push({
      label: "Skill categories",
      value: Object.entries(extractedFields.skills.skillCategories)
        .map(([category, skills]) => `${category}: ${skills || [].join(", ")}`)
        .join(", ")
    });
  }

  if (
    extractedFields.certifications &&
    extractedFields.certifications.length > 0
  ) {
    for (const [
      index,
      certification
    ] of extractedFields.certifications.entries()) {
      dataItems.push({
        label: `Certification ${index + 1}`,
        value: `${certification.certificationName} - ${certification.issuingOrganization}`,
        fullWidth: true
      });
    }
  }

  if (
    extractedFields.additionalSections?.publications &&
    extractedFields.additionalSections.publications.length > 0
  ) {
    dataItems.push({
      label: "Publications",
      value: extractedFields.additionalSections?.publications?.join(", ")
    });
  }

  if (
    extractedFields.additionalSections?.patents &&
    extractedFields.additionalSections.patents.length > 0
  ) {
    dataItems.push({
      label: "Patents",
      value: extractedFields.additionalSections?.patents?.join(", ")
    });
  }

  if (
    extractedFields.additionalSections?.awards &&
    extractedFields.additionalSections.awards.length > 0
  ) {
    dataItems.push({
      label: "Awards",
      value: extractedFields.additionalSections?.awards?.join(", ")
    });
  }

  if (
    extractedFields.additionalSections?.memberships &&
    extractedFields.additionalSections.memberships.length > 0
  ) {
    dataItems.push({
      label: "Memberships",
      value: extractedFields.additionalSections?.memberships?.join(", ")
    });
  }

  if (
    extractedFields.additionalSections?.volunteerExperience &&
    extractedFields.additionalSections.volunteerExperience.length > 0
  ) {
    for (const [
      index,
      experience
    ] of extractedFields.additionalSections.volunteerExperience.entries()) {
      dataItems.push({
        label: `Volunteer experience ${index + 1}`,
        value: `${experience.organization} - ${experience.role}`,
        fullWidth: true
      });
    }
  }

  return dataItems;
};
